module.exports = __webpack_public_path__ + "img/feature_7.0101524.png";